module.exports = __webpack_public_path__ + "static/fonts/aeonik-bold.2e0f4774.woff";